/**
 * Subdomain Router Utility
 * Handles subdomain-based routing for personal profiles
 */

export function getSubdomain(): string | null {
  const hostname = window.location.hostname;

  // Handle localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Check for subdomain in development via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('subdomain');
  }

  // Handle production domains
  const parts = hostname.split('.');

  // Check if it's a subdomain of redheli.com
  if (parts.length >= 3 && parts.slice(-2).join('.') === 'redheli.com') {
    return parts[0];
  }

  // Check for staging/dev environments
  if (hostname.includes('run.app')) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('subdomain');
  }

  return null;
}

export function isPersonalProfile(): boolean {
  const subdomain = getSubdomain();
  // List of personal profile subdomains
  const personalSubdomains = ['jen', 'jennifer'];
  return personalSubdomains.includes(subdomain || '');
}

export function redirectToProfile(): void {
  const subdomain = getSubdomain();
  if (subdomain === 'jen' || subdomain === 'jennifer') {
    // If we're on jen.redheli.com, redirect to the profile route
    if (window.location.pathname === '/' || window.location.pathname === '') {
      window.location.pathname = '/jen';
    }
  }
}